import { Injectable } from '@angular/core';
import { Customer } from '../models/customer';
import { CustomerAddress } from '../models/customer-address';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http:HttpClient) { }

  async getCustomers(type?:string, activeAddress?:boolean) : Promise<Customer[]> {
    let paramsTmp:{[key: string]: any} = {};
    if (type) {
      paramsTmp.type = type;
    }
    if (activeAddress) {
      paramsTmp.active_addresses = activeAddress;
    }
    return this.http.get<Customer[]>('/api/customer', {params: paramsTmp}).toPromise();
  }

  async postCustomer(customer:Customer) : Promise<Customer> {
    return this.http.post<Customer>('/api/customer', customer).toPromise();
  }

  async getCustomer(id:Number) : Promise<Customer> {
    return this.http.get<Customer>('/api/customer/' + id).toPromise();
  }
  
  async putCustomer(customer:Customer) : Promise<Customer> {
    return this.http.post<Customer>('/api/customer/' + customer.id + '/edit', customer).toPromise();
  }
  
  async deleteCustomer(customer:Customer) : Promise<void> {
    return this.http.get<void>('/api/customer/' + customer.id + '/delete').toPromise();
  }

  async postCustomerAddress(address:CustomerAddress) : Promise<CustomerAddress> {
    return this.http.post<CustomerAddress>('/api/customer/address', address).toPromise();
  }

  async putCustomerAddress(address:CustomerAddress) : Promise<CustomerAddress> {
    return this.http.post<CustomerAddress>('/api/customer/address/' + address.id + '/edit', address).toPromise();
  }
  
  async deleteCustomerAddress(address:CustomerAddress) : Promise<void> {
    return this.http.get<void>('/api/customer/address/' + address.id + '/delete').toPromise();
  }
}
